var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.856,
    height: 20.3,
    viewBox: "0 0 15.856 20.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Delete_4375733",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27052",
    "data-name": "Group 27052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45384",
    "data-name": "Path 45384",
    d: "M18.616,4.5H15.133V4a1.481,1.481,0,0,0-1.462-1.5H10.923A1.481,1.481,0,0,0,9.461,4v.5H5.978A1.481,1.481,0,0,0,4.516,6v.89A1.506,1.506,0,0,0,5.3,8.211V20a2.469,2.469,0,0,0,2.436,2.5h9.124A2.469,2.469,0,0,0,19.292,20V8.211a1.506,1.506,0,0,0,.78-1.321V6a1.481,1.481,0,0,0-1.456-1.5ZM10.435,4a.494.494,0,0,1,.487-.5h2.748a.494.494,0,0,1,.487.5v.5H10.435ZM5.491,6a.494.494,0,0,1,.487-.5H18.616A.494.494,0,0,1,19.1,6v.89a.494.494,0,0,1-.487.5H5.978a.494.494,0,0,1-.487-.5ZM16.859,21.5H7.735A1.481,1.481,0,0,1,6.273,20V8.39H18.32V20A1.481,1.481,0,0,1,16.859,21.5ZM12.784,11v7.881a.487.487,0,1,1-.975,0V11a.487.487,0,1,1,.975,0Zm3.508,0v7.881a.487.487,0,1,1-.975,0V11a.487.487,0,1,1,.975,0ZM9.276,11v7.881a.487.487,0,1,1-.975,0V11a.487.487,0,1,1,.975,0Z",
    transform: "translate(-4.516 -2.5)",
    fill: "#bfbfbf",
    stroke: "#bfbfbf",
    strokeWidth: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.b5dabcc4.svg";
export { ForwardRef as ReactComponent };